import React, { useContext, useState } from 'react';
import { FlatList, Platform, SafeAreaView, StyleSheet, View } from 'react-native';
import { ListItem, Tab } from '@rneui/base';
import PropTypes from 'prop-types';
import { H6, Paragraph2 } from '../../text';
import LayoutContext from '../../../contexts/Layout';

const AccordionListItem = props => {
    const { layout } = useContext(LayoutContext);
    const [expanded, setExpanded] = useState(false);
    const broadcasts = props?.broadcasts;
    const label = props?.label;

    const renderHeading = () => {
        return (
            <View
                style={StyleSheet.flatten(Styles.accordionListItemHeader, { borderBottomColor: '#8897a2', paddingBottom: layout.styleGuide.spacer3 })}
                dataSet={{ spacerBottom: `StyleGuide.Spacer3(${layout.styleGuide.spacer3})` }}
            >
                <View style={{ justifyContent: 'flex-start' }}>
                    <Paragraph2 text='Station' />
                </View>
                <View style={{ justifyContent: 'flex-end' }}>
                    <Paragraph2 text='Broadcast Time' />
                </View>
            </View>
        );
    };

    const renderContent = () => {
        return broadcasts.map((broadcast, index) => {
            const id = broadcast?.id;
            const day = broadcast?.day;
            const station = broadcast?.station;
            const time = broadcast?.time;
            const timeZone = broadcast?.timeZone;
            const oddStyle = index % 2 !== 0 ? { backgroundColor: '#f7f8f9' } : undefined;

            return (
                <View
                    key={id}
                    style={StyleSheet.flatten(Styles.accordionListItemWrapper, oddStyle, { paddingVertical: layout.styleGuide.spacer2 })}
                    dataSet={{ spacerBottom: `StyleGuide.Spacer2(${layout.styleGuide.spacer2})`, spacerTop: `StyleGuide.Spacer2(${layout.styleGuide.spacer2})` }}
                >
                    <View style={{ marginBottom: layout.styleGuide.spacer4 }} dataSet={{ spacerBottom: `tyleGuide.Spacer4(${layout.styleGuide.spacer4})` }}>
                        <H6 style={{ color: '#8897a2' }} text={station} />
                    </View>
                    <View>
                        <H6 style={{ color: '#8897a2' }} text={`${day}, ${time}, ${timeZone}`} />
                    </View>
                </View>
            );
        });
    };

    return (
        <View
            style={{ marginHorizontal: layout.styleGuide.spacer1, marginTop: layout.styleGuide.spacer4 }}
            dataSet={{
                spacerLeft: `StyleGuide.Spacer1(${layout.styleGuide.spacer1})`,
                spacerRight: `StyleGuide.Spacer1(${layout.styleGuide.spacer1})`,
                spacerTop: `StyleGuide.Spacer4(${layout.styleGuide.spacer4})`
            }}
        >
            <ListItem.Accordion
                content={<H6 style={Styles.accordionContent} text={label.replaceAll('_', ', ')} />}
                containerStyle={StyleSheet.flatten(Styles.accordionListItemContainer, { paddingBottom: layout.styleGuide.spacer4 })}
                icon={{
                    name: 'chevron-down',
                    size: 10,
                    type: 'font-awesome-5'
                }}
                isExpanded={expanded}
                onPress={() => setExpanded(!expanded)}
            >
                <ListItem containerStyle={{ marginBottom: layout.styleGuide.spacer2 }} pad={0}>
                    <ListItem.Content style={Styles.listItemContent}>
                        {renderHeading()}
                        {renderContent(broadcasts)}
                    </ListItem.Content>
                </ListItem>
            </ListItem.Accordion>
        </View>
    );
};

export const Broadcast = ({ items, nodeTypeAlias = 'Broadcast' }) => {
    const { layout } = useContext(LayoutContext);
    const [active, setActive] = useState(0);
    const [activeBroadcast, setActiveBroadcast] = useState();
    const groups = Object.values(items);

    const aggregateGroup = group => {
        const aggregated = {};

        Object.values(group.contentItems ?? {}).forEach(child => {
            const market = child?.market;
            const station = child?.station;
            const key = `${market}, ${station}`;

            if (aggregated.hasOwnProperty(key)) {
                aggregated[key].push(child);
            } else {
                aggregated[key] = [child];
            }
        });

        return aggregated;
    };

    const toggleAccordion = val => {
        if (val === activeBroadcast || !val) {
            setActiveBroadcast(undefined);
        } else {
            setActiveBroadcast(val);
        }
    };

    if (groups?.length === 0) {
        return null;
    }

    return (
        <View style={{ width: '100%' }} dataSet={{ umbracoComponentName: nodeTypeAlias }}>
            <Tab
                containerStyle={{ textAlign: 'center' }}
                indicatorStyle={{ alignSelf: 'center', backgroundColor: '#a61a2b', height: 1 }}
                onChange={value => {
                    setActive(value);
                    toggleAccordion();
                }}
                value={active}
            >
                {groups.map((group, index) => {
                    return (
                        <Tab.Item
                            // buttonStyle={{ justifyContent: 'flex-end' }}
                            dataSet={{ spacerBottom: `StyleGuide.Spacer4(${layout.styleGuide.spacer4})` }}
                            key={index}
                            title={group.head}
                            // titleStyle={StyleSheet.flatten(layout.styleGuide.h5, Styles.tabTitle, { margin: 0, padding: 0, paddingBottom: layout.styleGuide.spacer4 })}
                            type='clear'
                        />
                    );
                })}
            </Tab>
            {groups.map((group, index) => {
                if (index === active) {
                    return (
                        <View
                            key={index}
                            style={{ flexDirection: 'row', justifyContent: 'center', marginBottom: layout.styleGuide.spacer2, marginTop: layout.styleGuide.spacer4 }}
                            dataSet={{
                                spacerBottom: `StyleGuide.Spacer2(${layout.styleGuide.spacer2})`,
                                spacerTop: `StyleGuide.Spacer4(${layout.styleGuide.spacer4})`
                            }}
                        >
                            <H6 style={{ color: '#8897a2' }} text={group.description} />
                        </View>
                    );
                }

                return null;
            })}
            {groups.map((group, index) => {
                const data = Object.entries(aggregateGroup(group));

                if (Array.isArray(data) && active === index) {
                    return (
                        <SafeAreaView key={index} style={{ flex: 1 }}>
                            <FlatList
                                data={data}
                                keyExtractor={item => item[0]}
                                renderItem={entry => <AccordionListItem broadcasts={entry.item[1]} label={entry.item[0]} />}
                            />
                        </SafeAreaView>
                    );
                }

                return null;
            })}
        </View>
    );
};

const Styles = StyleSheet.create({
    accordionContent: {
        fontSize: Platform.OS === 'web' ? '11pt' : 11,
        lineHeight: Platform.OS === 'web' ? '15pt' : 15,
        letterSpacing: Platform.OS === 'web' ? '2pt' : 2,
        textTransform: 'uppercase'
    },
    accordionListItemContainer: {
        borderBottomColor: '#8897a2',
        borderBottomWidth: 1,
        cursor: Platform.OS === 'web' ? 'pointer' : undefined,
        flex: 1,
        justifyContent: 'space-between'
    },
    accordionListItemWrapper: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        padding: 0
    },
    accordionListItemHeader: {
        alignItems: 'stretch',
        borderBottomWidth: 1,
        cursor: Platform.OS === 'web' ? 'pointer' : undefined,
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    listItemContent: {
        alignItems: 'stretch'
    },
    tabTitle: {
        fontFamily: 'GothamBook',
        fontSize: Platform.OS.equals('web') ? '16pt' : 16,
        lineHeight: Platform.OS.equals('web') ? '18pt' : 18,
        margin: 0,
        padding: 0
    }
});

Broadcast.propTypes = {
    items: PropTypes.shape({
        contentItems: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.string.isRequired,
                day: PropTypes.string,
                market: PropTypes.string,
                medium: PropTypes.string,
                station: PropTypes.string,
                time: PropTypes.string,
                timeZone: PropTypes.string
            })
        )
    })
};
